
import { mapGetters, mapState } from "vuex";
import { Component, Vue, Watch } from "vue-property-decorator";
import { watch } from "vue";
import Event from "@/models/Event";


@Component({
  computed: {
    ...mapState("EventRegistration", [
      "event", "choossenGroepsGrootte"
    ]),
  }
})
export default class GroepsFilter extends Vue {
  groepsgrootte: string = "0";
  items: string[] = [];

  @Watch("event", { immediate: true })
  async eventChanged(event: Event) {

    if (event.name != "Loading") {
      this.items = [];
      for (let index = 0; index <= this.$store.state.EventRegistration.event.maxgroepsregistratie; index++)
      {
          if (index > 0)
            this.items.push(index.toString());
          else
            this.items.push('');
      }
      this.groepsgrootte = this.$store.state.EventRegistration.choossenGroepsGrootte.toString();
    }
  }

  @Watch("choossenGroepsGrootte", { immediate: true })
  async groepsgrootteChanged(groepsGrootte: number) {

    this.groepsgrootte = groepsGrootte.toString();
  }

  @Watch("groepsgrootte")
  selectionChanged(groepsgrootte: string) {
    try {
      const groepsgrootteInput = document.getElementById(
        "han_vastlegginggroepsgrootte"
      ) as HTMLInputElement;

      if (groepsgrootteInput)
        groepsgrootteInput.value = groepsgrootte;
    } catch (error) {

    }
    this.$store.state.EventRegistration.choossenGroepsGrootte = groepsgrootte;
    this.$store.commit("EventRegistration/filterChanged", {
      type: "GroepsGrootte",
      values: groepsgrootte
    });
    this.$store.commit("EventRegistration/recalculateFilters");
  }

}
